import React from "react";
import { Step, StepOption } from "../../../types/wizard";

interface RadioGroupProps {
  step: Step,
  selectedValue: string;
  onChange?: (option: StepOption) => void; // Callback to handle changes
}

const RadioGroup: React.FC<RadioGroupProps> = ({ step, selectedValue, onChange }) => {
  const { title, options } = step;

  return (
    <>
      <div className="w-full">
        {selectedValue?.toLowerCase() !== 'custom' && title &&
          <h4 className="font-bold text-lg my-4">{title}</h4>
        }

        {/* Disclaimer */}
        {step.disclaimer && (
          <div className="flex flex-row pb-4 w-full">
            <div
              dangerouslySetInnerHTML={{
                __html: step.disclaimer.message,
              }}
              className="list-disc pl-6"
            ></div>
          </div>
        )}

        {/* Radio options */}
        {options.map((option, index) => (
          <div className="radio-button" key={option.id}
            style={{ display: selectedValue?.toLowerCase() === 'custom' ? 'none' : '' }}>
            <input
              type="radio"
              name={`${title?.toLowerCase().replace(/\s/g, "-")}-option`}
              id={`${option.id}`}
              value={option.name}
              checked={
                (selectedValue?.toLowerCase() === option.code?.toLowerCase() ||
                  selectedValue?.toLowerCase() === option.name?.toLowerCase() ||
                  !selectedValue && index === 0)
              }
              onChange={() => onChange?.(option)}
            />
            <label htmlFor={`${option.id}`} className="form-check-label">
              {option.name}
            </label>
          </div>
        ))}
      </div>
      <div className="mb-2">
        <hr className="dashed-title" />
      </div>
    </>
  );
};

export default RadioGroup;
